import { type IPrivateContactCompany } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IPrivateContactCompanyState } from './types';

export const GET_FROM_CONTACT = 'getFromContact';

const getPrivateContactCompany = (_state: IPrivateContactCompanyState, ids = [] as number[]): IPrivateContactCompany[] => {
    return ids
        .map((privateContactLeadId: number) => {
            return _state.dataObjectList.get(privateContactLeadId);
        })
        .filter((privateContactLead) => {
            return privateContactLead;
        });
};

export const getters: GetterTree<IPrivateContactCompanyState, unknown> = {
    [GET_FROM_CONTACT]: (_state: IPrivateContactCompanyState) => {
        return (contactId: number): IPrivateContactCompany[] => {
            return getPrivateContactCompany(_state, _state.byContact.get(contactId) ?? []);
        };
    }
};
